// Central HTTP error normalization
export class HttpError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = "HttpError";
    this.status = status;
    this.data = data;
  }
}

export function toHttpError(err) {
  if (!err || !err.response) {
    return new HttpError(err?.message || "Network error", 0, null);
  }
  return new HttpError(
    err.response.statusText || "Request failed",
    err.response.status,
    err.response.data
  );
}